import { render, staticRenderFns } from "./login-page.vue?vue&type=template&id=b53a460e&scoped=true"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"
import style0 from "./login-page.vue?vue&type=style&index=0&id=b53a460e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53a460e",
  null
  
)

export default component.exports